//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import dateFormat from 'dateformat';
// import TagManager from 'react-gtm-module';

//components
import DevolucoesLista from '../childrens/devolucoesLista/.mixins/DevolucoesLista';
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Devolucoes_controller from '../../../../../../controllers/devolucoes';

export default class Devolucoes extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            title: 'Devoluções',
            itens: [],
            itensTable: [],
            columns: [],
            isLoading: false,
            filters: {
                datas: true,
                flagsPag: false
            },
        }

        this.loadData = this.loadData.bind(this);
        this.setState = this.setState.bind(this);
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:devolucoes',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-devolucoes',
        //     }
        // });
    }

    UNSAFE_componentWillMount() {
        /* this.loadData(this, null); */
    }

    async loadData(props, filters) {
        
        const cookies = new Cookies();
        var json = JSON.parse(await Devolucoes_controller.getDevolucoes(cookies.get('User-Token'),filters));
        if (json.status) {

            var colunas = [
                'NFD',
                'Filial',
                'Valor R$',
                'Emissão',
                'Vencimento',
                'Observação N.F.',
                'Qtd. Item',
                'Numérico',
                'Alpha',
                'Cor',
                'Transportadora',
                'Valor Liquido',
                'Num. Item',
                'N.F. Origem',
                'Emis. N.F. Origem'
            ];

            //prepara dados para tabela
            var arrayItens = [];
            json.itens.forEach(element => {
                arrayItens.push([
                    element.nfd,
                    element.filial,
                    element.valor,
                    element.emissao?dateFormat(new Date(element.emissao), "dd/mm/yyyy" ):null,
                    element.vencimento?dateFormat(new Date(element.vencimento), "dd/mm/yyyy" ):null,
                    element.observacao,
                    element.qtdItem,
                    element.numerico,
                    element.alpha,
                    element.cor,
                    element.transportadora,
                    element.valorLiquido,
                    element.numItem,
                    element.nfOrigem,
                    element.emisNfOrigem?dateFormat(new Date(element.emisNfOrigem), "dd/mm/yyyy" ):null
                ]);
            });

            props.setState({
                itens:colunas,
                itensTable:arrayItens,
                isLoading: false,
                columns: colunas
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:devolucoes',
            //       eventAction: 'callback',
            //       eventLabel: `sucesso:lista-devolucoes`,
            //     }
            // });

        } else {
            const erroString = 'Erro ao carregar dados de devoluções!';
            props.child.current.retorno(erroString,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:devolucoes',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${erroString}`,
            //     }
            // });
        }

    }

    render() {
        return (
            <div>
                <DevolucoesLista {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    }

}